import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { WS_EVENTS } from '../../../lib/websocket/events';
import { useWebSocket } from '../../../lib/websocket/WebSocketProvider';

import { P1_KEY } from './use-p1';

/**
 * D10 — tela de crise: liga os WS events do P1 à invalidação React Query.
 * Qualquer evento (detected/acknowledged/handled/resolved/closed/escalated/
 * volume-critical/bypassed-offline) re-busca a lista + o volume-status, mantendo
 * a sala de situação viva durante o pico.
 */
export function useP1WsSync(): void {
  const qc = useQueryClient();
  const { subscribe } = useWebSocket();
  useEffect(() => {
    const invalidate = (): void => void qc.invalidateQueries({ queryKey: P1_KEY });
    const offs = [
      WS_EVENTS.P1_DETECTED,
      WS_EVENTS.P1_ACKNOWLEDGED,
      WS_EVENTS.P1_HANDLED,
      WS_EVENTS.P1_RESOLVED,
      WS_EVENTS.P1_CLOSED,
      WS_EVENTS.P1_AUTO_ESCALATED,
      WS_EVENTS.P1_SEVERITY_ESCALATED,
      WS_EVENTS.P1_VOLUME_CRITICAL,
      WS_EVENTS.P1_BYPASSED_OFFLINE_ATTENDANT,
    ].map((evt) => subscribe(evt, invalidate));
    return () => {
      for (const off of offs) off();
    };
  }, [qc, subscribe]);
}
